import { useEffect, useState } from "react";
import { getPrintersApi, IPrinter, OfflineProvider, PrinterModel } from "grabcad-printers-api";

export const useCatalogPrinterModel = (printer: IPrinter) => {
    const [printerModel, setPrinterModel] = useState<PrinterModel>();

    useEffect(() => {
        const catalog = getPrintersApi(new OfflineProvider()).getCatalog();
        // try and match on printer model "name". This works for FDM printers and most PJ printers where
        // the PJ printers machineName and machineDisplayName (from their internal DB) are the same
        catalog
            .findPrinterModelsByCatalogItem({ name: printer.getModelName() })
            .then((matchingPrinters) => {
                if (matchingPrinters.length === 1) {
                    setPrinterModel(matchingPrinters[0]);
                } else {
                    // try to match on internalName. This works for PJ printers whose internal name is different
                    catalog
                        .findPrinterModelsByCatalogItem({ internalName: printer.getModelName() })
                        .then((matchingPrinters2) => {
                            if (matchingPrinters2.length === 1) {
                                setPrinterModel(matchingPrinters2[0]);
                            } else {
                                console.warn(
                                    `Unable to find unique match for printer model in Catalog. Model Name is ${printer.getModelName()}`
                                );
                            }
                        })
                        .catch((e) => {
                            console.warn(
                                `Failure to call the printers api ICatalog.findPrinterModelsByCatalogItem(): ${e}`
                            );
                        });
                }
            })
            .catch((e) => {
                console.warn(
                    `Failure to call the printers api ICatalog.findPrinterModelsByCatalogItem(): ${e}`
                );
            });
    }, [printer]);

    return { printerModel };
};
